const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAffiliateTokenApi = async () => {
    const token = localStorage.getItem('token'); 
    try {
        const response = await fetch(
            `${API_BASE_URL}/affiliator/integration/token`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`, 
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || 'Ошибка при получении токена');
        }

        const data = await response.json();
        return data?.token || null; 
    } catch (error) {
        console.error('Ошибка при получении токена:', error);
        throw error;
    }
};